module.exports = __webpack_public_path__ + "img/time.e9a88c82.svg";